import { Outlet, useParams } from 'react-router';

import { Toaster } from '@valwin/facto/components';

import { useGTM } from '~features/analytics';
import { useInitFacebookSdk } from '~features/integrations';

export function AppProvider() {
  const { pharmacyId } = useParams<{ pharmacyId?: string }>();

  useGTM({ pharmacyId });
  useInitFacebookSdk();

  return (
    <div className="app">
      <Toaster />
      <Outlet />
    </div>
  );
}
